/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import $ from 'jquery';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { each, filter } from 'underscore';
import debounce from 'hs-lodash/debounce';
import { Events } from 'Backbone';
import { HS_ANCHOR_ATTRIBUTE } from 'tinymce-plugins/constants/hsanchor';
import { getGlobalGroupElements, getGlobalPartialElements, getWidgetElement } from 'InpageEditorUI/lib/inpage/utils';
import ModuleEditorStore from 'InpageEditorUI/lib/ModuleEditorStore';
import { normalizedKey } from 'ContentEditorUI/lib/InpageUtils';
import EditContainer from 'InpageEditorUI/containers/EditContainer';
import { EVENT_REACT_DND_TEARDOWN_START } from 'ContentEditorUI/lib/inpage/Constants';
import { documentClick, hideModuleHoverMenu, iframeWindowResize, positionModuleMenu } from 'InpageEditorUI/eventsAsActions/editTransitionEventsAsActions';
import { updateContainers } from 'InpageEditorUI/eventsAsActions/layoutTransitionEventsAsActions';
import { detachRedirectDetector } from 'InpageEditorUI/lib/detectCriticalFailures';
import { previewScrollTop, previewDocumentHeight, previewBodyHeight } from 'InpageEditorUI/lib/previewDimensions';
import { getContainerElementByName, getModuleMenuPositionInfo, scrollToElementIfOffscreen, scrollToModuleElementIfBoundsOffScreenAtAll } from 'InpageEditorUI/lib/dom';
import { subscribeToSelectedItemIdChanges } from 'ContentEditorUI/redux/stateSubscribers';
import { getIsFocusModeOn } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import { layoutSectionHoverPositionsCleared, layoutSectionNodePositionsCleared } from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { togglePauseRedux } from 'ContentEditorUI/lib/debugging/pauseReduxDebugging';
import InpageContext from 'InpageEditorUI/context/InpageContext';
import { getPickerComponentsProvider } from 'InpageEditorUI/context/pickerComponentsWithState';
import { updateComputedStylesForSelectors } from 'InpageEditorUI/eventsAsActions/widgetEditorTransitionEventsAsActions';
import MultiTourHandlerSingleton from 'ui-shepherd-react/lib/MultiTourHandlerSingleton';
import UITour from 'ui-shepherd-react/tour/UITour';
import { TourSyncController } from 'ContentEditorUI/controllers/TourSyncController';
import { clearUseScrollIfModuleOutOfBoundsAtAll } from 'ContentEditorUI/redux/actions/selectionActions';
import { getUseScrollIfModuleOutOfBoundsAtAll } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import { getModuleById, getGlobalModuleNames } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { BusProvider } from '../context/Bus';
import { fetchHTMLTextFromDocument } from './editControllerHelpers';
import { getSelectedModuleName } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { getSelectorForModuleByName } from 'InpageEditorUI/lib/dom';
import { focusMode } from 'InpageEditorUI/lib/focusMode';
import { setSuperstoreUserSetting } from 'ContentEditorUI/redux/actions/settingsActions';
import { HAS_SEEN_EMBED_TOUR, HAS_SEEN_SECTIONS_LIBRARY_ONBOARDING_TOUR } from 'ContentEditorUI/lib/userAndLocalCacheSettings/constants';
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { CASE_STUDY_ONBOARDING_TOUR_KEY, CASE_STUDY_ONBOARDING_TOUR_STEPS } from '../components/onboarding/CaseStudyOnboardingTour';
import { ThemeProvider } from 'foundations-theming/components/ThemeProvider';
import { SECTIONS_LIBRARY_TOUR, SECTIONS_LIBRARY_TOUR_STEPS } from 'ContentEditorUI/constants/tours';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class EditController {
  busEvents() {
    return {
      'post:setInpageScroll': this.setScroll,
      'post:toggleScrollingAllowed': this.onToggleScrollingAllowed,
      'post:getComputedStyle': this.getComputedStyle,
      'post:getComputedStylesForSelectors': this.getComputedStylesForSelectors,
      'post:listenForComputedStyleChangesForRowOrColumn': this.listenForComputedStyleChangesForRowOrColumn,
      'post:stopListeningForComputedStyleChangesForRowOrColumn': this.stopListeningForComputedStyleChangesForRowOrColumn,
      'post:getTopViewportWidget': this.getTopViewportWidget,
      // Smart content manager
      'post:setSmartWidgetDefault': this.setSmartWidgetDefault,
      'post:previewNeedsReload': this.handlePreviewNeedsReload,
      'post:togglePauseRedux': this.togglePauseRedux,
      'post:getTinyAnchors': this.getTinyAnchors,
      'post:updateNodePositions': this.updateNodePositions,
      'post:checkModuleForInlineEditableHubDBFields': this.getInlineHubDBFieldsForModule,
      // used with useEditControllerMethod
      'post:getHTMLTextContext': this.getHTMLTextContext,
      'post:toggleEditorFocusMode': this.toggleFocusMode,
      'post:clearHoverPositions': this.clearHoverPositions
    };
  }
  constructor({
    bus,
    store
  }) {
    this.tellParentToHideModuleMenu = () => {
      delete this.overlayPositionInfo;
      this.bus.dispatchActionToEventBus(hideModuleHoverMenu());
    };
    this.handleDocumentClick = e => {
      this.bus.dispatchActionToEventBus(documentClick());
      const $target = $(e.target);
      if ($target.closest('a[href]').length && !$target.closest('[class*=mce-]').length) {
        e.preventDefault();
      }
    };
    this.initializeTours = () => {
      this.tourHandler.registerTour('BLOG_PLG_ONBOARDING', {
        steps: ['postName', 'postBody', 'metaDescription', 'author', 'featuredImage', 'template', 'publish']
      });
      this.tourHandler.registerTour('embed-editor-onboarding-tour', {
        steps: ['welcome', 'addContent', 'contentTree', 'editEmbed', 'previewEmbed'],
        beforeExit: () => {
          this.store.dispatch(setSuperstoreUserSetting(HAS_SEEN_EMBED_TOUR, Date.now()));
        }
      });
      this.tourHandler.registerTour(SECTIONS_LIBRARY_TOUR, {
        steps: SECTIONS_LIBRARY_TOUR_STEPS,
        beforeExit: () => {
          this.store.dispatch(setSuperstoreUserSetting(HAS_SEEN_SECTIONS_LIBRARY_ONBOARDING_TOUR, Date.now()));
        }
      });
      this.tourHandler.registerTour(CASE_STUDY_ONBOARDING_TOUR_KEY, {
        steps: Object.values(CASE_STUDY_ONBOARDING_TOUR_STEPS)
      });
    };
    this.setScroll = message => {
      if (message.value) {
        $(document).scrollTop(message.value);
      } else if (message.by) {
        $(document).scrollTop(previewScrollTop() + message.by);
      }
    };
    this.onWindowResize = data => {
      this.sendWindowHeightUpdate();
      this.setModuleMenuPosition(data);
      this.repositionActiveTinyMCE();
    };
    this.repositionActiveTinyMCE = debounce(() => {
      if (this.tinymceActiveEditorExists()) {
        const tinymce = window.tinymce;
        tinymce.activeEditor.nodeChanged();
      }
    }, 10);
    this.setModuleMenuPosition = () => {
      let positionInfo = {};
      if (this.overlayPositionInfo) {
        positionInfo = Object.assign({
          scrollTop: previewScrollTop()
        }, this.overlayPositionInfo);
      } else {
        positionInfo = getModuleMenuPositionInfo();
        positionInfo.scrollTop = previewScrollTop();
      }
      this.bus.dispatchActionToEventBus(positionModuleMenu(positionInfo));
    };
    this.scrollToWidget = widgetId => {
      const state = this.store.getState();
      const useScrollIfModuleOutOfBoundsAtAll = getUseScrollIfModuleOutOfBoundsAtAll(state);
      if (document.readyState !== 'complete') {
        this.scrollToWidgetId = widgetId;
        document.addEventListener('readystatechange', this.scrollToWidgetOnCompleteCallback);
        return;
      }
      if (widgetId) {
        $('html, body').stop(true);
        const imWidget = getModuleById(state, widgetId);
        if (!imWidget) {
          return;
        }
        const widget = imWidget.toJS();
        const {
          $widget: $widgetInDom
        } = getWidgetElement(widget);
        if (this.widgetEditorExists(widget)) {
          const widgetEditor = ModuleEditorStore.get(widgetId);
          if (widgetEditor.$widget.length > 0) {
            if (widgetEditor.$widget[0] !== $widgetInDom[0]) {
              console.error('Dom and WidgetEditor mismatch');
            }
            if (useScrollIfModuleOutOfBoundsAtAll) {
              scrollToModuleElementIfBoundsOffScreenAtAll(widgetId);
              this.clearUseScrollIfModuleOutOfBoundsAtAllCallback();
            } else {
              scrollToElementIfOffscreen(widgetEditor.$widget);
            }
          }
        }
      } else {
        let globalElements = getGlobalGroupElements(widgetId);
        if (!globalElements.length) {
          globalElements = getGlobalPartialElements(widgetId);
        }
        if (globalElements.length) {
          const $globalElement = $(globalElements[0]);
          scrollToElementIfOffscreen($globalElement);
        }
      }
    };
    this.setSmartWidgetDefault = message => {
      for (let i = 0; i < this.allWidgets.length; i++) {
        const widget = this.allWidgets[i];
        const widgetEditor = ModuleEditorStore.get(widget.name);
        if (message.name === widget.name && widgetEditor.tiny) {
          widgetEditor.tiny.setContent(message.content);
        }
      }
    };
    this.getComputedStyleFor = selector => {
      const $widget = $(selector);
      if ($widget.length) {
        const filteredStyles = {};
        const styles = window.getComputedStyle($widget.get(0));
        const supportedStyles = window.HS_INLINE_STYLE.supportedStyles;
        for (let i = 0, len = supportedStyles.length; i < len; i++) {
          const propertyName = supportedStyles[i];
          filteredStyles[propertyName] = styles[propertyName];
        }
        return filteredStyles;
      }
      return undefined;
    };
    this.getComputedStyle = message => {
      let selector = '';
      if (message.selector && $.type(message.id) === 'string' && message.id.indexOf('el__') < 0) {
        if (message.id.indexOf('__') >= 0) {
          message.id = message.id.split('__')[0];
        }
        selector = `#hs_cos_wrapper_${message.id} ${message.selector}`;
      } else if (message.selector) {
        selector = message.selector;
      } else {
        selector = `#hs_cos_wrapper_${message.id}`;
      }
      const filteredStyles = this.getComputedStyleFor(selector) || {};

      // In order for the Interframe callback to work in the parent frame
      // we need to post message back with the original format of the message,
      // instead of dispatching a "fake" redux actions with dispatchActionToEventBus
      this.bus.postMessage(Object.assign({}, message, {
        response: filteredStyles
      }));
    };
    this.getTinyAnchors = message => {
      const anchors = Array.from(document.querySelectorAll(`a[${HS_ANCHOR_ATTRIBUTE}]`)).map(node => ({
        id: node.id
      }));
      this.bus.postMessage(Object.assign({}, message, {
        response: anchors
      }));
    };
    this.getComputedStylesForSelectors = message => {
      if (!message.selectors) {
        throw new Error('Expected `selectors` to be on the getComputedStylesForSelectors message');
      }
      const filteredStylesBySelector = message.selectors.reduce((result, selector) => {
        result[selector] = this.getComputedStyleFor(selector);
        return result;
      }, {});

      // In order for the Interframe callback to work in the parent frame
      // we need to post message back with the original format of the message,
      // instead of dispatching a "fake" redux actions with dispatchActionToEventBus
      this.bus.postMessage(Object.assign({}, message, {
        response: filteredStylesBySelector
      }));
    };
    this.listenForComputedStyleChangesForRowOrColumn = message => {
      this.computedStyleListeners[message.name] = debounce(() => {
        const computedStylesBySelector = message.selectors.reduce((result, selector) => {
          result[selector] = this.getComputedStyleFor(selector);
          return result;
        }, {});
        this.bus.dispatchActionToEventBus(updateComputedStylesForSelectors(computedStylesBySelector));
      }, 1000, {
        maxWait: 1000,
        leading: false,
        trailing: true
      });
      window.addEventListener('resize', this.computedStyleListeners[message.name]);
    };
    this.stopListeningForComputedStyleChangesForRowOrColumn = message => {
      window.removeEventListener('resize', this.computedStyleListeners[message.name]);
    };
    this.onToggleScrollingAllowed = scrollOptions => {
      const {
        allowed
      } = scrollOptions;
      const overflow = allowed ? 'auto' : 'hidden';
      $('html, body').css({
        overflow
      });
    };
    this.getHTMLTextContext = message => {
      const selectedModuleName = getSelectedModuleName(this.store.getState());
      const globalModuleNames = getGlobalModuleNames(this.store.getState());
      const moduleDomElement = getContainerElementByName(selectedModuleName);
      const selector = message.editorSelector || 'body';
      const globalModuleSelectors = globalModuleNames.map(name => getSelectorForModuleByName(name));
      let response = '';
      if (moduleDomElement) {
        moduleDomElement.insertAdjacentHTML('beforebegin', '<span id="temp-focus-start-annotator"><<</span>');
        moduleDomElement.insertAdjacentHTML('afterend', '<span id="temp-focus-end-annotator">>></span>');
        response = fetchHTMLTextFromDocument(selector, globalModuleSelectors);
        document.getElementById('temp-focus-start-annotator').remove();
        document.getElementById('temp-focus-end-annotator').remove();
      } else {
        response = fetchHTMLTextFromDocument(selector, globalModuleSelectors);
      }
      this.bus.postMessage(Object.assign({}, message, {
        response: {
          textContent: response
        }
      }));
    };
    this.clearHoverPositions = () => {
      this.store.dispatch(layoutSectionHoverPositionsCleared());
    };
    this.initializeFocusMode = () => {
      // if the superstore setting for focus mode is true, we want to
      // toggle focus mode once the dom is ready
      if (EditorConfigSingleton.getIsOnScalableEditor() &&
      // Since focusMode is only available to KBv3 right now, we are
      // stepping around the existing feature flag validation by performing
      // our conditional checks in this way. The below issue is a follow up
      // to refactor this as an experimentalFeature flag to ensure we have
      // proper validation: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/17667
      // Once focusMode is an "official" feature flag, we can graduate it to
      // the proper features slice of the editorConfig: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/17568
      EditorConfigSingleton.get('features')['focusMode'] && getIsFocusModeOn(this.store.getState())) {
        this.toggleFocusMode({
          value: true
        });
        this.bus.postMessage({
          action: 'hideFocusModeLoadingOverlay'
        });
      }
    };
    Object.assign(this, Events);
    this.i18nInitializedPromise = new Promise(resolve => {
      this.resolveI18nInitializedPromise = resolve;
    });
    this.bus = bus;
    this.store = store;
    this.widgetEditors = {};
    this.domReady = document.readyState === 'complete' || document.readyState === 'interactive';
    this.startCalled = false;
    this.lastUpdatePreviewWidgetTimestampByName = {};
    this.handlePreviewNeedsReload = this.handlePreviewNeedsReload.bind(this);
    this.shouldShowFakeWidgetEditors = this.shouldShowFakeWidgetEditors.bind(this);
    this.moveWidgetInFlexColumn = this.moveWidgetInFlexColumn.bind(this);
    this.tellParentToHideModuleMenu = this.tellParentToHideModuleMenu.bind(this);
    this.updateNodePositions = this.updateNodePositions.bind(this);
    this.scrollToWidget = this.scrollToWidget.bind(this);
    this.onDomReady = this.onDomReady.bind(this);
    this.clearUseScrollIfModuleOutOfBoundsAtAllCallback = this.clearUseScrollIfModuleOutOfBoundsAtAllCallback.bind(this);
    this.scrollToWidgetOnCompleteCallback = this.scrollToWidgetOnCompleteCallback.bind(this);
    if (!this.domReady) {
      document.addEventListener('DOMContentLoaded', this.onDomReady);
    }
    this.computedStyleListeners = {};
    this.scrollToWidgetId = null;
    this.tourHandler = MultiTourHandlerSingleton.getInstance();
    this.toggleFocusMode = focusMode(this.store);
  }
  onDomReady() {
    this.domReady = true;
    // If the dom is ready before start was called,
    // don't do this stuff, because start will handle
    // itself
    if (this.startCalled) {
      document.body.appendChild(this.reactTreeRoot);
      this.setupImageLoadListeners();
      this.renderReactTree();
      this.initializeFocusMode();
    }
  }
  start({
    moveableWidgetElements,
    allContainers,
    allWidgets,
    gates,
    isBlog,
    moduleMissingErrors,
    tinyMceGlobals
  }) {
    this.allContainers = allContainers;
    this.allWidgets = allWidgets;
    this.gates = gates;
    this.moveableWidgetElements = moveableWidgetElements;
    this.tinyMceGlobals = tinyMceGlobals;
    this.isBlog = isBlog;
    this.moduleMissingErrors = moduleMissingErrors;
    if (allWidgets == null || gates == null) {
      throw new Error('EditController must be passed allWidgets and gates on start');
    }
    this.initializeTours();
    this.createInpageReactTreeElement();
    this.renderReactTree();
    if (this.domReady) {
      this.initializeFocusMode();
      this.setupImageLoadListeners();
    }
    this.registerEvents();
    this.startCalled = true;
  }
  handlePreviewNeedsReload() {
    const inpageIframeWindow = window;

    // Make sure we disable our redirection detection logic when the parent is
    // about to reload the iframe
    detachRedirectDetector();

    // If the inpage iframe window has react-dnd setup (in the case of
    // being in layout mode or having the new Inpage Sidebar), we need
    // to make sure we teardown the react-dnd instances on both of those
    // iframes.
    if (inpageIframeWindow.__isReactDndBackendSetUp) {
      inpageIframeWindow.__reactDndTeardownComplete = () => {
        this.reloadNow();
      };
      inpageIframeWindow.postMessage({
        type: EVENT_REACT_DND_TEARDOWN_START
      }, '*');

      // Otherwise, we're not in layout mode and we don't have the new
      // Inpage Sidebar, so we should just trigger a real reload.
    } else {
      this.reloadNow();
    }
  }
  reloadNow() {
    this.bus.postMessage({
      action: 'refreshInpageFrame',
      scrollX: window.scrollX,
      scrollY: window.scrollY
    });
  }
  getColumnReference(allContainers, flexColumnName) {
    return allContainers.find(c => c.name === flexColumnName);
  }
  getWidgetInColumnReference(allContainers, flexColumnName, widgetName) {
    return this.getColumnReference(allContainers, flexColumnName).widgets.find(w => w.name === widgetName);
  }
  makeColumnHaveNewRefence(columnToChangeReference) {
    this.allContainers = this.allContainers.map(container => {
      if (container === columnToChangeReference) {
        return Object.assign({}, container);
      }
      return container;
    });
  }
  moveWidgetInFlexColumn(fromWidgetName, fromColumnName, fromWidgetElement, flexColumnToMoveToId, flexColumnDropIndex) {
    const theWidgetToMove = this.getWidgetInColumnReference(this.allContainers, fromColumnName, fromWidgetName);

    // Find and replace the widget in the old column with a temorary placeholdre
    const oldColumn = this.getColumnReference(this.allContainers, fromColumnName);
    const indexInOldColumn = oldColumn.widgets.indexOf(theWidgetToMove);
    const placeholderWidget = {
      TO_DELETE_ME: true
    };
    oldColumn.widgets.splice(indexInOldColumn, 1, placeholderWidget);

    // Find new column to add to, and splice in module at proper index
    const theColumnToMoveTo = this.getColumnReference(this.allContainers, flexColumnToMoveToId);
    theColumnToMoveTo.widgets.splice(flexColumnDropIndex, 0, theWidgetToMove);

    // Actually move the DOM node that was dragging
    const containerElement = getContainerElementByName(flexColumnToMoveToId);
    const widgetImmediatelyAfter = theColumnToMoveTo.widgets[flexColumnDropIndex + 1];
    const widgetElementImmediatelyAfter = widgetImmediatelyAfter ? getWidgetElement(widgetImmediatelyAfter).$widget.get(0) : undefined;
    containerElement.insertBefore(fromWidgetElement, widgetElementImmediatelyAfter);

    // Remove the placeholder
    const placeholderIndexInOldColumn = oldColumn.widgets.indexOf(placeholderWidget);
    oldColumn.widgets.splice(placeholderIndexInOldColumn, 1);

    // Use a shallow clone to force PureComponent/shouldComponentUpdate to see an update
    this.makeColumnHaveNewRefence(oldColumn);
    if (theColumnToMoveTo !== oldColumn) {
      this.makeColumnHaveNewRefence(theColumnToMoveTo);
    }

    // Force a rerender of the react tree with this new order state
    this.renderReactTree();

    // Need to change the data format for posting back to parent frame
    const parentContainersFormat = this.allContainers.map(flexColumn => {
      return {
        id: flexColumn.name,
        widgets: flexColumn.widgets.map(widget => normalizedKey(widget))
      };
    });

    // Inform the parent frame that the order has changed
    this.bus.dispatchActionToEventBus(updateContainers(parentContainersFormat));
  }
  widgetEditorExists(widget) {
    return typeof widget !== 'undefined' && widget !== null && ModuleEditorStore.get(widget.name);
  }
  tinymceActiveEditorExists() {
    const tinymce = window.tinymce;
    return typeof tinymce !== 'undefined' && tinymce !== null && typeof tinymce.activeEditor !== 'undefined' && tinymce.activeEditor !== null;
  }
  registerEvents() {
    subscribeToSelectedItemIdChanges(this.store, this.scrollToWidget);

    // Bus event binding
    const busEvents = this.busEvents();
    Object.keys(busEvents).forEach(eventName => {
      const handler = busEvents[eventName];
      this.listenTo(this.bus, eventName, handler);
    });
    document.addEventListener('click', this.handleDocumentClick, true);
    $(window).on('resize', this.onWindowResize);
    $(document).on('scroll', e => {
      this.setModuleMenuPosition(e);
    });
  }
  setupImageLoadListeners() {
    const images = $('img');
    const totalImages = images.length;
    let completed = 0;
    const checkAllCompleted = () => {
      if (completed === totalImages) {
        this.onAllImagesLoaded();
      }
    };
    const onImageLoadOrError = () => {
      completed += 1;
      checkAllCompleted();
    };
    if (!totalImages) {
      this.onAllImagesLoaded();
    } else {
      images.each((i, img) => {
        const proxyImg = new Image();
        proxyImg.onload = onImageLoadOrError;
        proxyImg.onerror = onImageLoadOrError;
        proxyImg.src = img.src;
      });
    }
  }
  onAllImagesLoaded() {
    this.sendWindowHeightUpdate();
  }

  // Scroll/position helpers

  getTopViewportWidget(message) {
    let topViewportWidget = {
      name: 'top',
      top: previewDocumentHeight()
    };
    const windowScroll = previewScrollTop();
    if (windowScroll > 0) {
      each(this.allWidgets, widget => {
        if (widget.name === 'preview_text') {
          return;
        }
        const widgetId = `#hs_cos_wrapper_${widget.name}`;
        const widgetTop = $(widgetId).offset().top;
        if (widgetTop >= windowScroll && widgetTop <= topViewportWidget.top) {
          topViewportWidget = {
            name: widgetId,
            top: widgetTop
          };
        }
      });
    }
    this.bus.postMessage(Object.assign({}, message, {
      response: topViewportWidget.name
    }));
  }
  createInpageReactTreeElement() {
    this.reactTreeRoot = document.createElement('div');
    this.reactTreeRoot.className = '_HS-react-root';
    // Explicitly set LTR for the react tree root to prevent potential
    // customer RTL languages from bleeding into our UI layer
    this.reactTreeRoot.dir = 'ltr';
    // If the DOM is ready by the time this is called
    // then attach the react tree root to the body now,
    // otherwise it'll get attached to the body later on
    // dom ready
    if (this.domReady) {
      document.body.appendChild(this.reactTreeRoot);
    }
  }
  i18nInitialized() {
    this.resolveI18nInitializedPromise();
  }
  renderReactTree() {
    const {
      tourHandler
    } = this;
    this.i18nInitializedPromise.then(() => {
      ReactDOM.render( /*#__PURE__*/_jsx(ThemeProvider, {
        children: /*#__PURE__*/_jsx(Provider, {
          store: this.store,
          children: /*#__PURE__*/_jsx(BusProvider, {
            bus: this.bus,
            children: /*#__PURE__*/_jsx(InpageContext.Provider, {
              value: {
                tinyMceGlobals: this.tinyMceGlobals,
                pickerComponentsWithState: getPickerComponentsProvider(this.store)
              },
              children: /*#__PURE__*/_jsxs(UITour, {
                multiTourHandler: tourHandler,
                tours: ['BLOG_PLG_ONBOARDING', 'embed-editor-onboarding-tour', CASE_STUDY_ONBOARDING_TOUR_KEY, SECTIONS_LIBRARY_TOUR],
                activateOnMount: true,
                children: [/*#__PURE__*/_jsx(TourSyncController, {
                  bus: this.bus,
                  tourKey: "BLOG_PLG_ONBOARDING",
                  tourEnv: "preview"
                }), /*#__PURE__*/_jsx(TourSyncController, {
                  bus: this.bus,
                  tourKey: "embed-editor-onboarding-tour",
                  tourEnv: "preview"
                }), /*#__PURE__*/_jsx(TourSyncController, {
                  bus: this.bus,
                  tourKey: CASE_STUDY_ONBOARDING_TOUR_KEY,
                  tourEnv: "preview"
                }), /*#__PURE__*/_jsx(TourSyncController, {
                  bus: this.bus,
                  tourKey: SECTIONS_LIBRARY_TOUR,
                  tourEnv: "preview"
                }), /*#__PURE__*/_jsx(EditContainer, {
                  allContainers: this.allContainers,
                  domReady: this.domReady,
                  bus: this.bus,
                  gates: this.gates,
                  previewLoaded: this.domReady,
                  onScrollToWidget: this.scrollToWidget,
                  shouldShowFakeWidgetEditors: this.shouldShowFakeWidgetEditors,
                  sidebarIframeWindow: this.sidebarIframeWindow,
                  updateFlexColumnContents: this.moveWidgetInFlexColumn,
                  tellParentToHideModuleMenu: this.tellParentToHideModuleMenu,
                  updateNodePositions: this.updateNodePositions,
                  getComputedStyleFor: this.getComputedStyleFor,
                  moduleMissingErrors: this.moduleMissingErrors,
                  handlePreviewNeedsReload: this.handlePreviewNeedsReload
                })]
              })
            })
          })
        })
      }), this.reactTreeRoot);
    });
  }

  // TODO, Not needed because the whole iframe is reloaded, right?
  unmountReactTree() {
    ReactDOM.unmountComponentAtNode(this.reactTreeRoot);
  }
  shouldShowFakeWidgetEditors() {
    const omitBlogEditableWidgets = widgets => {
      return filter(widgets, w => w.name !== 'post_body' && w.name !== 'name' && w.type !== 'space');
    };
    const sidebarEditableWidgets = filter(this.allWidgets, w => w.overrideable === true || w.export_to_template_context === true);
    return omitBlogEditableWidgets(sidebarEditableWidgets).length > 0;
  }
  sendWindowHeightUpdate() {
    this.bus.dispatchActionToEventBus(iframeWindowResize(previewBodyHeight()));
  }
  scrollToWidgetOnCompleteCallback() {
    if (document.readyState === 'complete') {
      this.scrollToWidget(this.scrollToWidgetId);
      this.scrollToWidgetId = null;
      document.removeEventListener('readystatechange', this.scrollToWidgetOnCompleteCallback);
    }
  }

  //
  // Smart Content Manager
  //
  //
  // Style Manager
  //
  updateNodePositions() {
    this.store.dispatch(layoutSectionNodePositionsCleared());
  }
  lastUpdatePreviewWidgetForWidget(widgetId) {
    return this.lastUpdatePreviewWidgetTimestampByName[widgetId];
  }
  setLastUpdatePreviewWidgetForWidget(widgetId, originalTimestamp) {
    this.lastUpdatePreviewWidgetTimestampByName[widgetId] = originalTimestamp;
  }
  togglePauseRedux() {
    togglePauseRedux();
  }
  clearUseScrollIfModuleOutOfBoundsAtAllCallback() {
    this.store.dispatch(clearUseScrollIfModuleOutOfBoundsAtAll());
  }
}